import React from 'react'

function HomeBox9() {
    return (
        <div className='homebox9' id='homebox9'>
            <div className='container'>
                <div className='homebox9-main'>
                    <div className='HomeBox7-top' id='homebox9-top'>
                        <h1>Discover insights across all your loyalty data</h1>
                        <p>Track engagement, rewards, and customer activity in real time</p>
                    </div>
                    <div className='homebox9-content'>
                        <img src="/img-analytics.webp" alt="box9-img" />
                        <a href="https://merchant.loyalific.com/login">Explore your analytics</a>
                        <p>Free 15 days trial | Dedicated support | No Setup Fees</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeBox9